import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f0f10] text-[#f5f5f5] py-12 border-t border-[#2d3748]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="text-xl font-bold tracking-wider">
              <span className="text-[#4b63eb]">JACKSONVILLE</span>
              <span className="text-[#f5f5f5] ml-2">PHOTO</span>
            </div>
            <p className="text-sm text-[#a0a0a0] leading-relaxed">
              Professional architectural photography capturing the beauty of residential and commercial spaces.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold tracking-widest uppercase text-[#4b63eb]">Quick Links</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-sm text-[#a0a0a0] hover:text-[#4b63eb] transition-colors duration-300">
                Home
              </Link>
              <Link to="/portfolio" className="text-sm text-[#a0a0a0] hover:text-[#4b63eb] transition-colors duration-300">
                Portfolio
              </Link>
              <Link to="/about" className="text-sm text-[#a0a0a0] hover:text-[#4b63eb] transition-colors duration-300">
                About
              </Link>
              <Link to="/contact" className="text-sm text-[#a0a0a0] hover:text-[#4b63eb] transition-colors duration-300">
                Contact
              </Link>
            </nav>
          </div>

          {/* Connect */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold tracking-widest uppercase text-[#4b63eb]">Connect</h3>
            <p className="text-sm text-[#a0a0a0]">
              Jacksonville, Florida
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="p-2 bg-[#2d3748] rounded-full hover:bg-[#4b63eb] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="p-2 bg-[#2d3748] rounded-full hover:bg-[#4b63eb] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <Link
                to="/contact"
                className="p-2 bg-[#2d3748] rounded-full hover:bg-[#4b63eb] transition-colors duration-300"
                aria-label="Email"
              >
                <Mail size={18} />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#2d3748]/30 text-center">
          <p className="text-sm text-[#a0a0a0]">
            © {currentYear} Jacksonville Photo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
